var lists_default = {
  "fontElementMap": "_2whNa",
  "orderedlist": "xzG2T",
  "bulletedlist": "OA7qz",
  "listItem": "hAVdE"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
